import moment from 'moment'
import { useQuery } from 'react-query'
import { Line } from "react-chartjs-2"
import { getCSSVariableValue } from "../../../../../_metronic/assets/ts/_utils"

import { getUserChart } from "../../../../models/statistics"
import PageSpinner from '../../../../components/Spinner/PageSpinner'
import PageError from '../../../../components/Error/PageError'


const MonthlyUsersChart = () => {
    const { isLoading, isError, error, data: { data: { labels, datasets } = {} } = {} } = useQuery('statistic-user-chart-current-month', () => getUserChart({
        startPubDate: moment().startOf('month').format('YYYYMMDD'),
        endPubDate: moment().format('YYYYMMDD')
    }))

    if (isLoading) return <PageSpinner height={200} color="success" />
    if (isError) return <PageError height={200}>{error.message}</PageError>

    return (
        <Line
            options={{
                maintainAspectRatio: false,
                elements: {
                    line: {
                        tension: 0.4
                    },
                    point: {
                        radius: 0
                    }
                },
                scales: {
                    x: {
                        display: false
                    },
                    y: {
                        display: false
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            }}
            data={{
                labels: labels,
                datasets: datasets ? datasets.map(dataset => ({
                    ...dataset,
                    fill: true,
                    backgroundColor: getCSSVariableValue('--kt-success-light'),
                    borderColor: getCSSVariableValue('--kt-success'),
                })) : []
            }}
        />
    )
}

export default MonthlyUsersChart